import typography from '../typography'

export default (palette) => ({
  root: {
    ...typography.body1,
    borderBottom: `1px solid ${palette.divider}`,
    color: palette.text.primary,
  },
  head: {
    fontSize: '0.72rem', // Compacto e arrojado 📐
    fontWeight: 700,
    letterSpacing: '1px',
    // Arquitetura Suprema: Usa a cor de texto oficial da Tabela para total isolamento visual! 💎🚀🛰️
    color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
    textTransform: 'uppercase',
    backgroundColor: 'transparent',
    '& svg': {
      color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`, // Ícones brancos/claros reativos
    },
    // 🛡️ Sincronia Absoluta para Ordenação Centralizada
    '& .MuiTableSortLabel-root': {
      color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
      '&:hover': {
        color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
      },
      '&.MuiTableSortLabel-active': {
        color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
        '& .MuiTableSortLabel-icon': {
          color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
        },
      },
      '& .MuiTableSortLabel-icon': {
        color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
      }
    }
  }
})
